jQuery(function($) {
  const viewportHeight = function() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };
  viewportHeight();
  window.addEventListener('resize', viewportHeight);
});